import { GAEvent, GTMEvent } from '@/typings/base'
import {
  clearItemVariantFromGAParamsIfNotChalhoub,
  isChalhoub,
  safeDataLayerPush,
} from '@/utils/gtag'
import * as gtag from '../utils/gtag'
import { numberToPrice } from './utils'

export function sendPurchaseGA(lastOrder) {
  if (!lastOrder) return

  const order_purchased = JSON.parse(localStorage.getItem('order_purchased'))

  if (
    localStorage.getItem('Payment type') === '3dSecure' &&
    order_purchased?.tokenValue !== lastOrder.tokenValue &&
    order_purchased?.checkoutCompletedAt !== lastOrder.checkoutCompletedAt
  ) {
    const gaParams = {
      transaction_id: lastOrder?.tokenValue,
      currency: lastOrder.currency,
      value: numberToPrice(lastOrder?.totals?.total),
      tax: numberToPrice(lastOrder?.totals?.taxes),
      shipping: numberToPrice(lastOrder?.totals?.shipping),
      payment_method: '3dSecure',
      items: lastOrder.items.map(({ product, quantity, total }) => {
        const firstVariant: any = Object.values(product?.variants)[0]
        return {
          ['item_name']: product.name,
          ['item_id']: isChalhoub ? firstVariant?.sku : product.code,
          ['item_variant']: isChalhoub && firstVariant?.code,
          price: numberToPrice(total),
          quantity,
        }
      }),
    }
    localStorage.setItem(
      'order_purchased',
      JSON.stringify({
        tokenValue: lastOrder.tokenValue,
        checkoutCompletedAt: lastOrder.checkoutCompletedAt,
      })
    )
    const cleanGAParams = clearItemVariantFromGAParamsIfNotChalhoub(gaParams)
    gtag.tracker(GAEvent.PURCHASE, cleanGAParams)
  }
}

export function sendPurchaseGTM(lastOrder) {
  if (!lastOrder) return

  const order_purchased = JSON.parse(localStorage.getItem('order_purchased'))
  if (
    order_purchased?.tokenValue !== lastOrder.tokenValue &&
    order_purchased?.checkoutCompletedAt !== lastOrder.checkoutCompletedAt
  ) {
    const gtmParams = {
      event: GTMEvent.PURCHASE,
      ecommerce: {
        transaction_id: lastOrder?.tokenValue,
        value: numberToPrice(lastOrder?.totals?.total),
        tax: numberToPrice(lastOrder?.totals?.taxes),
        shipping: numberToPrice(lastOrder?.totals?.shipping),
        discount: -numberToPrice(lastOrder?.totals?.promotion),
        items: lastOrder.items.map(
          ({ product, quantity, total, totalWithoutPromotion }) => {
            const firstVariant: any = Object.values(product?.variants)[0]
            return {
              affiliation: product?.channelCode,
              coupon: lastOrder?.couponCode,
              discount:
                total && totalWithoutPromotion
                  ? numberToPrice(totalWithoutPromotion - total)
                  : 0,
              price: numberToPrice(total),
              currency: lastOrder?.currency,
              quantity,
              item_id: firstVariant?.sku || product?.code,
              item_name: product?.name,
              item_category: product?.taxons?.main,
              item_list_id: product?.slug,
              item_list_name: product?.taxons?.main,
              item_variant: firstVariant?.name,
            }
          }
        ),
      },
    }

    safeDataLayerPush(gtmParams)
  }
}
